import React from 'react';
import { Score } from '../Score/Score';

interface GuessProps{
  guess: string[];
  score: string[]
}

export class Guess extends React.Component<GuessProps>{
  generateGuessNodes(): React.ReactNode[]{
    const nodes: React.ReactNode[] = [];
    const { guess } = this.props;
    guess.forEach( (color, index) => {
      nodes.push(
        <div  key={index} 
              className='h-full rounded-sm aspect-square'
              style={{backgroundColor: color}}></div>
      )
    })
    return nodes;
  }

  render(): React.ReactNode{
    return (
      <div className = "flex flex-row items-center justify-center w-full h-[12.5%] min-h-[32px] gap-1">
        {this.props.guess.length !== 0 && this.generateGuessNodes()}
        {this.props.score.length !== 0 && <div className='w-0.5 h-full mx-2 bg-onBackgroundTextColor'></div> }
        {this.props.score.length !== 0 && <Score score={this.props.score}/>}
      </div>
    )
  }
}
